export enum Origin {
  MyMoviesHeader = 'completed_button',
  MyMoviesEmptyState = 'empty_state_button',
  BoosterThumbnail = 'booster_thumbnail',
  MyBrandMenu = 'my_brand_menu'
}
